// extracted by mini-css-extract-plugin
module.exports = {"headLabel":"e_-s","title":"e_at","subTitle":"e_bt","promoted":"e_ct"};